export default class PackUtils {

    public static readonly GOLD_SUM = 180000;
    public static readonly PLATINUM_SUM = 250000;
    public static readonly DOMINATOR_SUM = 600000;

    public static getMythDiscount(gemsCount: number) {
        if (gemsCount == PackUtils.GOLD_SUM) {
            return 25;
        } else if (gemsCount == PackUtils.PLATINUM_SUM) {
            return 50;
        } else if (gemsCount >= PackUtils.PLATINUM_SUM) {
            return 80;
        }
        return 0;
    }
}
